<div #op [ngStyle]="styles" class="prs-dropdown">
  <ng-content></ng-content>
</div>